import events from './events'
import store from 'reducers'
import Actions from './Actions'
import {SelectedPatientActions, OrganizationActions, LoadingActions} from 'actions'
import _ from 'lodash'

export default class PatientActions extends Actions{
    static get target(){
        return 'patients'
    }
    
    static fetch(data) {
        LoadingActions.set({
            patients: true
        })
        return OrganizationActions.findPatientDataByID(data.organizationID).then((res)=>{
            return this.client.patients.fetch(data).then((response)=>{
                let _data = {}
                let siblingIDs = (store.getState().organization.siblings || []).map((sibling)=>sibling.id)
                if(Array.isArray(response.data)){
                    response.data.forEach((value)=>{
                        if(value.primaryOrganizationID && (
                            store.getState().organization.id == value.primaryOrganizationID ||
                            (store.getState().organization.parentID && store.getState().organization.parentID == value.primaryOrganizationID) ||
                            siblingIDs.includes(value.primaryOrganizationID)
                        )){
                            _data[value.id] = value
                        }
                    })
                } else {
                    _data = response.data
                }

                LoadingActions.set({
                    patients: false
                })
                this.set(_data)
                events.trigger('Patient.dataFetched', data)
            })
        })
    }

    static append(patient){
        if(store.getState().selectedPatients[patient.id]){
            SelectedPatientActions.append(patient)
        }
        super.append(patient)
    }

    static appendMany(patients){
        let selectedPatients = store.getState().selectedPatients

        for(let key of Object.keys(patients)){
            if(selectedPatients[key]){
                selectedPatients = {
                    ...selectedPatients,
                    [`${key}`]: patients[key]
                }
            }
        }

        SelectedPatientActions.set(selectedPatients)

        super.appendMany(patients)
    }

    static onPatientSubmit(data) {
        events.trigger('Patient.patientDidSubmit', data)
    }
    
    static create(data) {
        let _data = {...data}
        delete data.id

        return this.client.patients.create({
                ...data,
                primaryOrganizationID: store.getState().organization.id
        }).then((response) =>{
            events.trigger('Patient.patientDidCreate', data)
            let returnData = {
                ...response.data,
                reason: data.reason
            }
            
            this.remove(_data)
            SelectedPatientActions.remove(_data)

            this.append(returnData)
            SelectedPatientActions.append(returnData)
            return {
                data: returnData
            }
        })
    }
    
    static update(data) {
        events.trigger('Patient.patientDidUpdate', data)
        return this.client.patients.update(data).then((response)=>{
            super.update({
                ...data,
                ...response.data
            })

            return {
                ...data,
                ...response.data
            }
        })
    }
}


// WEBPACK FOOTER //
// ./actions/PatientActions.js